import { render } from "./AddLabelModal.vue?vue&type=template&id=2e42e2b6"
import script from "./AddLabelModal.vue?vue&type=script&lang=js"
export * from "./AddLabelModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__